export default __webpack_public_path__ + "images/741d143d6b8e1547692d7afe09ebc0be-cultural_music_small.webp";